var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"deadPage"},[_c('h1',[_vm._v("V你50不要？")]),_c('div',{on:{"click":function($event){return _vm.playAgian()}}},[_vm._v("要")]),_c('div',{on:{"click":function($event){return _vm.back()}}},[_vm._v("不要了")])])}
var staticRenderFns = []

export { render, staticRenderFns }